import type { SVGProps } from 'react'
const SvgSyChat = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M12 1.254a10.7 10.7 0 0 0-7.6 3.142c-3.28 3.28-3.996 8.15-2.154 12.131l-.016-.035c.219.544.336.91.336 1.135 0 .356-.235.985-.445 1.656-.105.336-.201.69-.201 1.09s.139.881.482 1.225h.002c.344.343.822.482 1.223.482.4 0 .755-.098 1.09-.203.669-.21 1.295-.448 1.648-.451.218 0 .596.124 1.14.344l-.034-.016c3.981 1.841 8.85 1.126 12.13-2.154 4.188-4.189 4.196-11.008 0-15.204A10.72 10.72 0 0 0 12 1.254m0 1.492c2.367 0 4.734.904 6.541 2.711a9.24 9.24 0 0 1 0 13.082 9.25 9.25 0 0 1-10.44 1.854l-.035-.014c-.548-.22-1.066-.453-1.7-.453H6.36c-.834.005-1.537.344-2.093.52-.279.087-.512.134-.641.134-.13 0-.124-.002-.164-.043s-.043-.034-.043-.164.046-.363.133-.643c.174-.558.513-1.265.513-2.103 0-.627-.221-1.141-.443-1.693l-.016-.038A9.25 9.25 0 0 1 5.461 5.457 9.22 9.22 0 0 1 12 2.747"
				clipRule="evenodd"
			/>
			<path
				d="M15.94 11.414a1 1 0 0 0-1 1 1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-4.01 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1h.01a1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-4.008 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1h.008a1 1 0 0 0 1-1 1 1 0 0 0-1-1z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyChat
